<template>
  <v-container>
    <v-sheet class="mx-auto transparent" max-width="574">
      <v-card class="mb-3 px-3 py-5" :class="settings.graphics && settings.graphics.mode == 'low'
        ? 'low_plot'
        : 'plot'
        ">
        <v-card-text v-if="auth.Session">
          <!-- <div class="pt-1">
            <p class="text-h4 mt-3 text-center">Welcome Back!</p>
          </div> -->

          <!-- Show user info if authenticated -->
          <div class="text-center my-5" v-if="auth && auth.Player">
            <!-- Avatar using AbstractAvatar component -->
            <AbstractAvatar v-if="auth.Player.avatar" :avatar="auth.Player.avatar" :height="120" :width="120"
              class="mx-auto d-flex align-center justify-center"></AbstractAvatar>

            <!-- User Name -->
            <div class="black--text mb-2 text-h6">
              {{ auth.Student ? auth.Student.name : auth.User ? auth.User.name : auth.Player.name || 'Player' }}
            </div>

            <!-- Mochi ID if available -->
            <div v-if="auth.Player.mochiId" class="text-caption grey--text mb-4" style="font-weight: 100 !important">
              {{ auth.Player.mochiId }}
            </div>



            <!-- Continue Button -->
            <v-btn color="yellow" x-large @click="continueAsUser" block rounded class="text-h6 mb-3 pulse">
              {{ $t("action.continue") }}
            </v-btn>

            <v-divider class="my-4"></v-divider>

            <!-- Login as different user -->
            <v-btn color="grey lighten-1" text large @click="loginAsOtherUser" block rounded class="text-h6">
              {{ $t("action.loginAsDifferentUser") }}
            </v-btn>
          </div>
        </v-card-text>

        <div class="d-flex my-3">
          <v-spacer></v-spacer>
          <SiteLogo></SiteLogo>
          <v-spacer></v-spacer>
        </div>
      </v-card>
    </v-sheet>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {
    SiteLogo: () =>
      import(
        /* webpackChunkName: "component-site-logo" */ "@/components/SiteLogo.vue"
      ),
    AbstractAvatar: () =>
      import(
        /* webpackChunkName: "component-abstract-avatar-testing" */ "@/components/avatar/AbstractAvatar"
      ),
  },
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
      settings: (state) => state.settings.data,
    }),
  },
  data: () => ({
    //
  }),
  created() {
    // Check if auth exists, has Player, and has valid Session
    if (!this.auth || !this.auth.Player || !this.auth.Session) {
      this.loginAsOtherUser()
    }
  },
  methods: {
    continueAsUser() {
      try {
        // Send message to parent window (iframe parent) with entire auth object
        const message = {
          type: 'SSO_LOGIN_SUCCESS',
          success: true,
          auth: this.auth,
          timestamp: new Date().toISOString()
        };

        // Send message to parent window
        if (window.parent && window.parent !== window) {
          window.parent.postMessage(message, '*');
        }

        // Also log for debugging
        console.log('SSO Login Success message sent:', message);
      } catch (error) {
        console.error('Error sending SSO message:', error);
      }
    },

    loginAsOtherUser() {
      try {
        // Set SSO flag in sessionStorage
        sessionStorage.setItem('ssoFlow', 'true');

        // Redirect to logout page - no need for query params
        this.$router.push({ name: 'PageMainLogout' });
      } catch (error) {
        console.error('Error during logout:', error);
        // Even if message fails, still logout
        this.$router.push({ name: 'PageMainLogout' });
      }
    }
  },
};
</script>

<style scoped>
.plot {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 15px;
}

.low_plot {
  background: #f5f5f5;
  border-radius: 15px;
}

.pulse:hover {
  animation: none;
}

.pulse {
  animation: beat 0.5s infinite alternate;
  transform-origin: center;
}

/* Heart beat animation */
@keyframes beat {
  to {
    transform: scale(0.95);
  }
}
</style>